<template>
    <div class="custom-control custom-checkbox">
        <input class="custom-control-input"
               type="checkbox"
               v-model="isChecked"
               :id="getFieldId"
               :name="name"
               @input="updateValue">
        <label class="custom-control-label" :for="getFieldId" v-text="__(label)"></label>
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        data() {
            return {
                isChecked: this.value
            }
        },

        methods: {
            updateValue() {
                this.$emit('input', !this.isChecked)
                this.$emit('change', !this.isChecked)
            }
        },

        watch: {
            value(val) {
                this.isChecked = val;
            }
        }
    }
</script>
